module.exports = __webpack_public_path__ + "img/wxpage.41231958.png";